import {Directive, ElementRef, HostListener, Input, Optional} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appNoSpaces]'
})
export class NoSpacesDirective {
  // 'all' = ningún espacio | 'leading' = solo bloquea al inicio | 'trim' = limpia bordes al perder foco
  @Input() noSpacesMode: 'all' | 'leading' | 'trim' = 'all';

  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() private ngControl: NgControl
  ) {}

  @HostListener('input')
  onInput(): void {
    if (this.noSpacesMode === 'trim') return;

    const input = this.el.nativeElement;
    const original = input.value;
    const caret = input.selectionStart ?? original.length;

    const cleaned = this.clean(original);
    if (cleaned === original) return;

    // Conserva la posición del cursor restando los espacios eliminados antes del caret
    const newCaret = this.clean(original.slice(0, caret)).length;

    this.setValue(cleaned);
    input.setSelectionRange(newCaret, newCaret);
  }

  @HostListener('blur')
  onBlur(): void {
    if (this.noSpacesMode !== 'trim') return;

    const input = this.el.nativeElement;
    const trimmed = input.value.trim();
    if (trimmed !== input.value) {
      this.setValue(trimmed);
    }
  }

  private clean(value: string): string {
    if (this.noSpacesMode === 'all') return value.replace(/\s/g, '');
    if (this.noSpacesMode === 'leading') return value.replace(/^\s+/, '');
    return value;
  }

  private setValue(value: string): void {
    this.el.nativeElement.value = value;
    // Sincroniza con el FormControl / ngModel sin disparar validadores async de más
    this.ngControl?.control?.setValue(value, {emitEvent: false});
  }
}
